import { ChevronDown } from "lucide-react"
import { useMemo } from "react"
import { energyPassportProductColumns } from "@/features/energy-passport/ui/main-table/components/energy-passport-product-row.tsx"
import { EnergyPassportProductCell } from "@/features/energy-passport/ui/main-table/components/energy-product-product-cell.tsx"
import { calculateEnergyTotals } from "@/features/energy-passport/ui/main-table/model/lib.ts"
import { type IEnergyPassportQuarter, useEnergyPassportStore } from "@/features/energy-passport/ui/main-table/model/store.ts"
import { useCurrentUser } from "@/shared/hooks/use-current-user.ts"
import { showQuarterNumber } from "@/shared/lib/helper-functions.ts"
import CustomCheckbox from "@/shared/ui/custom-checkbox.tsx"

interface IProps {
  quarterRow: IEnergyPassportQuarter
}

export function EnergyPassportQuarterRow({ quarterRow }: IProps) {
  // Helpers
  const { isCompany } = useCurrentUser()

  // Store
  const { toggleQuarterRow } = useEnergyPassportStore()

  const totals = useMemo(() => calculateEnergyTotals(quarterRow.products), [quarterRow.products])

  return (
    <tr data-selected={quarterRow.expanded} className={`remove-bg mb-3.5 rounded-xl transition hover:bg-gray-50`}>
      <td className="bg-zinc-50 dark:bg-zinc-700">
        <div className="flex items-center gap-3">
          <CustomCheckbox
            initialState={"false"}
            className={isCompany ? "hidden" : ""}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
            }}
          />
          <button
            onClick={() => toggleQuarterRow(quarterRow.quarterNumber)}
            className="hover:!border-blue-400 flex items-center gap-3 rounded-lg border p-2.5 py-1.5 transition duration-100 hover:*:stroke-blue-500 active:border-blue-600 dark:border-zinc-500"
          >
            {showQuarterNumber(quarterRow.quarterNumber)}
            <ChevronDown className={`size-5 transition ${quarterRow.expanded ? "rotate-180" : ""}`} />
          </button>
        </div>
      </td>
      <td className="bg-zinc-50 dark:bg-zinc-700" />
      {energyPassportProductColumns.map((column, index) => (
        <EnergyPassportProductCell value={totals[column.field]} key={index} />
      ))}
      <td className="bg-zinc-50 dark:bg-zinc-700" />
    </tr>
  )
}
